/* Cliente del backoffice de telemetría (companion /telemetry). */

export interface Bucket {
  calls: number;
  errors: number;
  tokens: number;
  cost: number;
  ms: number;
}
export interface TelemetryEvent {
  ts: string;
  kind?: string;
  agent?: string;
  model?: string;
  ok?: boolean;
  ms?: number;
  cost?: number | null;
  error?: string;
}
export interface Telemetry {
  total: Bucket;
  today: Bucket;
  byAgent: Record<string, Bucket>;
  byModel: Record<string, Bucket>;
  recent: TelemetryEvent[];
}

export async function getTelemetry(): Promise<Telemetry> {
  const res = await fetch("https://localhost:3001/telemetry");
  if (!res.ok) throw new Error(`Telemetría ${res.status}`);
  return res.json();
}

/** Formatea un coste en USD con la precisión que tiene sentido a estas escalas. */
export function usd(n: number): string {
  if (!n) return "$0";
  return n < 0.01 ? `$${n.toFixed(4)}` : `$${n.toFixed(2)}`;
}
